import { Component } from '@angular/core';

@Component({
  selector: 'bor-about',
  standalone: false,
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent {}
